// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundRepeat = 'no-repeat';
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  let overlayRemoveTimeout;
  overlay.onclick = () => {
    clearTimeout(overlayRemoveTimeout);
    fillContainer(image);
    overlay.remove();
  }
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => {
    overlayRemoveTimeout = setTimeout(() => { 
      overlay.remove();
      fillContainer(image);
    }, 750);
  }
  overlay.onmouseenter = () => {
    clearTimeout(overlayRemoveTimeout);
  }
}

function fillContainer (image) {
  const opener = image.closest('modal-opener');
  const container = image.closest('.product-media-container');
  const imageContainer = image.closest('.product__media');

  if (opener && container && imageContainer) {
    [opener, container, imageContainer].forEach((el) => {
      if (el.style.height !== '100%') {
        el.style.height = '100%';
      } else {
        el.style.removeProperty('height');
      }
    });
  }
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      fillContainer(image);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
